/**
 * JS for expanding additional profiles in the prospectus.
 *
 * Show only one profile; if there are more, hide them behind an affordance,
 * and enable users to toggle the additional profiles.
 * This is a visual affordance only due to the length of the page. Screen reader
 * users can skip to the headings.
 */
$('.profiles').each(function () {
    var theList = $(this);
    var items   = $(this).children('li');

    if (items.length > 1) {
        // hide all but the first
        items.each(function (idx, e) {
            if (idx > 0) {
                $(this).addClass('surplus');
                $(this).addClass('offscreen');
            }
        });

        // add a toggle to make them slide in
        $(this).after('<button class="list_toggle" aria-hidden="true" role="presentation"><i class="fa fa-chevron-down"></i><span class="offscreen">Toggle Profiles</span></button><div class="profile_view_state">View More</div>');

        var button        = $(this).parent().find('button');
        var buttonText    = theList.parent().find('.profile_view_state');
        var fa            = $(this).parent().find('i');
        var animationTime = 400;
        var isVisible     = false;

        button.on('click', function () {
            var children = theList.children('li.surplus');

            // We are using a timeout to make sure icon and text change is triggered
            // only after all animation has been finished.
            // Not using callback function as it would be called multiple times
            // due to having multiple offscreen elements.
            setTimeout(function () {
                fa.toggleClass('fa-chevron-up fa-chevron-down');
                if (!isVisible) {
                    buttonText.html('View More');
                } else {
                    buttonText.html('View Less');
                }
            }, animationTime);

            if (!isVisible) {
                children.slideUp(0, function () {
                    children.removeClass('offscreen').slideDown(animationTime);
                });
                isVisible = true;
            } else {
                children.slideUp(animationTime, function () {
                    children.addClass('offscreen').slideDown(0);
                });
                isVisible = false;
            }
        });
    }
});
